// Client-side mirror of the API key rules in the backend (see the API Key OpenAPI spec).
// On top of them the UI only lets the global admin reveal, copy, change and revoke keys.

const hasRole = (user, role) => Boolean(user?.roles?.includes(role));

export const isOrganizationMember = (organization, username) =>
  Boolean(username) && Boolean(organization?.members?.some(m => m?.member === username));

// Backend: reveal/edit/delete are allowed only for the key's owner or a member of its organization - no admin exception
const hasKeyAccess = (apiKey, user, organizations) =>
  apiKey?.username === user?.username
  || isOrganizationMember(organizations?.find(org => org.id === apiKey?.organizationId), user?.username);

export const canManageApiKey = (apiKey, user, organizations) =>
  hasRole(user, "admin") && hasKeyAccess(apiKey, user, organizations);

// Backend: admins can create keys for any organization; managers only for organizations they are a member of
export const canCreateOrganizationApiKey = (organization, user) =>
  Boolean(organization) && (
    hasRole(user, "admin") || (hasRole(user, "manager") && isOrganizationMember(organization, user?.username))
  );
